import React, { useState } from "react";
import { IconButton, Badge, Menu, MenuItem, Typography, Divider, Box } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useNavigate } from "react-router-dom";
import { useBellCount } from "../hooks/useBellCount";
import { useBellItems, useMarkSeen } from "../hooks/useBellItems";
import { formatIsoDateWithTime } from "../utils/namesFormater";

const NotificationBell: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const navigate = useNavigate();

  const { data: bellCount = 0 } = useBellCount();
  const { data: bellItems = [] } = useBellItems(isOpen);
  const { mutate: markSeen } = useMarkSeen();

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (id: number, type: string) => {
    markSeen(id);
    handleCloseMenu();
    if (type === "shared_deal") {
      navigate("/users/shared-deals");
    }
  };

  return (
    <div>
      <IconButton color="inherit" onClick={handleOpenMenu}>
        <Badge
          badgeContent={bellCount || undefined}
          sx={{ "& .MuiBadge-badge": { backgroundColor: "orange", color: "white" } }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
        PaperProps={{ style: { maxHeight: 400, width: "380px", direction: "rtl" } }}
      >
        <Typography variant="h6" sx={{ px: 2, py: 1 }}>
          הודעות
        </Typography>
        <Divider />
        {bellItems.length > 0 ? (
          bellItems.map((item) => (
            <MenuItem key={item.id} onClick={() => handleItemClick(item.id, item.type)}>
              <Box>
                {item.source_company_name && (
                  <Typography variant="body2" fontWeight={600}>
                    {item.source_company_name}
                  </Typography>
                )}
                <Typography variant="body2">
                  {item.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.created_at ? formatIsoDateWithTime(item.created_at) : ""}
                </Typography>
              </Box>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>אין הודעות חדשות</MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default NotificationBell;
